import { render, staticRenderFns } from "./TasksHome.vue?vue&type=template&id=74d680ab"
import script from "./TasksHome.vue?vue&type=script&lang=js"
export * from "./TasksHome.vue?vue&type=script&lang=js"
import style0 from "./TasksHome.vue?vue&type=style&index=0&id=74d680ab&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74d680ab')) {
      api.createRecord('74d680ab', component.options)
    } else {
      api.reload('74d680ab', component.options)
    }
    module.hot.accept("./TasksHome.vue?vue&type=template&id=74d680ab", function () {
      api.rerender('74d680ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/pages/TasksHome.vue"
export default component.exports